module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/page_marker_active.1ae95189.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/page_marker_active.png
// module id = 3028
// module chunks = 11